import React, { useEffect, useState } from "react";
import { Alert, Badge, Button, Card, DatePicker, Input, Segmented, Space, Tag, Tooltip } from "antd";
import { PlusOutlined, CalendarOutlined } from "@ant-design/icons";
import { RoomServices } from "../../../Services/RoomServices";
import { navigate } from "../../../components/Customs/navigation";
import RoomCard from "../../../components/Rooms/book/RoomCard";
import TitleHead from "../../../components/Customs/TitleHead";
import axios from "axios";
import { ENDPOINTS } from "../../../Services/ENDPOINT";
import dayjs from "dayjs";
import { GeneralService } from "../../../Services/GeneralService";
import CustomDatePicker from "../../../components/Customs/CustomDatePicker";

import { Empty } from "antd";
import { canViewModule, canCreateModule } from "../../../../utils/permissionUtils";

const MODULE_KEY = "onsite_booking";

const SEGMENTS = [
  { label: "All", value: "all" },
  { label: "Available", value: "available" },
  { label: "Reserved", value: "reserved" },
  { label: "Occupied", value: "occupied" },
  { label: "House Keeping", value: "check_out" },
  { label: "Under Maintenance", value: "maintenance" },
];

const BookRoom = () => {
  const [rooms, setRooms] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [activeSegment, setActiveSegment] = useState("all");
  const [searchText, setSearchText] = useState("");
  const [upcomingMap, setUpcomingMap] = useState({}); // { room_id: [bookings] }
  const [getAllLog, setGetAllLog] = useState([]);

  const [bulkMode, setBulkMode] = useState(false);
  const [selectedRooms, setSelectedRooms] = useState([]);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split('T')[0]
  );
  const toggleRoomSelection = (room) => {
    setSelectedRooms((prev) => {
      const exists = prev.find((r) => r.id === room.id);
      if (exists) {
        return prev.filter((r) => r.id !== room.id);
      }
      return [...prev, room];
    });
  };

  const handleBulkBooking = () => {
    navigate("/bulk-room-booking", {
      state: {
        selectedRooms,
        roomIds: selectedRooms.map((r) => r.id),
      },
    });
  };

  const getAllRooms = async () => {
    try {
      // const res = await RoomServices.getAllRoom();
      const roe = new Date().toISOString().split('T')[0]; // yyyy-mm-dd

      const res = await RoomServices.getAllRoomByDate(roe);

      const roomsData = res?.data?.data || res?.data || [];
      setRooms(roomsData);
      if (Array.isArray(roomsData) && roomsData.length > 0) {
        setSelectedRoom(roomsData[0]);
      }
    } catch (error) {
      setRooms([]);
    }
  };

  const getAllLogs = async () => {
    try {

      const res = await GeneralService.get("book_log");
      setGetAllLog(res.data);

    } catch (error) {
    }
  };

  const getUpcomingReservations = async () => {
    try {
      const res = await axios.get(ENDPOINTS.UPCOMING_RESERVATIONS);
      const data = res.data?.data || [];
      // Group by room_id
      const map = {};
      data.forEach((b) => {
        if (!map[b.room_id]) map[b.room_id] = [];
        map[b.room_id].push(b);
      });
      setUpcomingMap(map);
    } catch (err) {
      console.error("Failed to fetch upcoming reservations", err);
    }
  };

  useEffect(() => {
    getAllRooms();
    getUpcomingReservations();
    getAllLogs();
  }, []);

  // console.log("getAllLog", getAllLog);

  const getBadgeColor = (status) => {
    switch (status) {
      case "available": return "gray";
      case "occupied": return "green";
      case "reserved": return "blue";
      case "maintenance": return "red";
      case "check_out": return "#c89d00ff";
      default: return "brown";
    }
  };

  const filteredRooms = rooms.filter((r) => {
    const matchesSegment =
      activeSegment === "all" ? true : r.status?.toLowerCase() === activeSegment;
    const matchesSearch =
      r.room_name?.toLowerCase().includes(searchText.toLowerCase()) ||
      r.room_number?.toString().includes(searchText);
    return matchesSegment && matchesSearch;
  });

  const getCount = (status) => {
    if (status === "all") return rooms.length;
    return rooms.filter((r) => r.status?.toLowerCase() === status).length;
  };

  const segmentOptions = SEGMENTS.map((seg) => ({
    label: (
      <Space>
        {seg.label}
        <Badge
          count={getCount(seg.value) || ` `} // always show badge
          showZero
          style={{
            backgroundColor: getBadgeColor(seg.value),
            color: "#ffffffff",
            borderRadius: "50%",
            minWidth: 22,
            height: 22,
            lineHeight: "22px",
            padding: 0,
            fontSize: 12,
            boxShadow: "0 0 0 2px #fff",
          }}
        />
      </Space>
    ),
    value: seg.value,
  }));

  const handleRoomStatusChange = async (room, newStatus) => {

    console.log("room, newStatus", room, newStatus);

    try {
      // await RoomServices.updateRoomStatus(room.id, newStatus);
      // Update the room status in the local state
      setRooms((prevRooms) =>
        prevRooms.map((r) => (r.id === room.id ? { ...r, status: newStatus } : r))
      );
    } catch (error) {
      console.error("Failed to update room status", error);
    }
  };

  const handleDateSelect = async (data, roe) => {
    console.log("data, roe", data, roe);

    try {
      setSelectedDate(roe)
      const req = await RoomServices.getAllRoomByDate(roe)
      setRooms(req.data)

    } catch (error) {
      console.error(error);

    }

  }

  if (!canViewModule(MODULE_KEY)) {
    return <Empty description="No permission to view this page" />;
  }


  return (
    <Card
      title={
        <TitleHead
          h1="Manage Room Booking"
          h2="Booking details, guest reservations & check-in/check-out management overview"
          extra={
            <Tag color="blue" style={{ fontSize: 14, padding: "0 8px" }}>
              Total Rooms: {rooms.length}
            </Tag>
          }
        />
      }
      extra={
        <Space>

          {/* <DatePicker  defaultValue={dayjs()} allowClear={false} size="large" onChange={handleDateSelect} /> */}
          <CustomDatePicker getAllLog={getAllLog} handleDateSelect={handleDateSelect} />

          <Button
            size="large"
            icon={<CalendarOutlined />}
            // type={bulkMode ? "primary" : "default"}
            danger={bulkMode ? true : false}
            onClick={() => {
              setBulkMode(!bulkMode);
              setSelectedRooms([]);
            }}
          >
            {bulkMode ? "Cancel Bulk Booking" : "Bulk Booking"}
          </Button>

          {canCreateModule(MODULE_KEY) && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => navigate("/add-room")}
              size="large"
            >
              Add New Room
            </Button>
          )}

        </Space>
      }
    >


      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24, gap: 16 }}>

        {/* <Segmented
          size="large"
          options={segmentOptions}
          value={activeSegment}
          onChange={setActiveSegment}
          style={{ fontSize: "16px", padding: "4px" }}
        /> */}
        <>
          <style>
            {`
      .custom-segmented .ant-segmented-item {
        border: 1px solid transparent;
        border-radius: 8px;
        transition: all 0.2s ease;
      }

      .custom-segmented .ant-segmented-item:hover {
        border: 1px solid #1677ff;
      }

      .custom-segmented .ant-segmented-item-selected {
        border: 1px solid darkgreen !important;
        color: darkgreen !important;
        font-weight: 600;
      }

      .custom-segmented .ant-segmented-item-selected:hover {
        border: 1px solid darkgreen !important;
      }
    `}
          </style>

          <Segmented
            size="large"
            options={segmentOptions}
            value={activeSegment}
            onChange={setActiveSegment}
            className="custom-segmented"
            style={{
              fontSize: "16px",
              padding: "4px",
            }}
          />
        </>

        <Input.Search
          placeholder="Search rooms by name or number"
          allowClear
          size="large"
          style={{ width: 400 }}
          onChange={(e) => setSearchText(e.target.value)}
          onSearch={(value) => setSearchText(value)}
        />
      </div>

      {bulkMode && selectedRooms.length > 0 && (
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
          message={
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>Total Selected Rooms: <b>{selectedRooms.length}</b></span>
              <Button type="primary" onClick={handleBulkBooking}>
                Book Selected Rooms
              </Button>
            </div>
          }
        />
      )}

      {bulkMode && selectedRooms.length <= 0 && (
        <Alert
          type="error"
          showIcon
          style={{ marginBottom: 16 }}
          message={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              Select a room card to proceed
              with bulk booking.
            </div>
          }
        />
      )}
      <RoomCard
        selectedDate={selectedDate}
        getAllRooms={getAllRooms}
        dataSource={filteredRooms}
        selectedRow={selectedRoom}
        onRowSelect={setSelectedRoom}
        upcomingMap={upcomingMap}
        bulkMode={bulkMode}
        selectedRooms={selectedRooms}
        onBulkSelect={toggleRoomSelection}
        onRoomStatusChange={handleRoomStatusChange}
      />

    </Card>
  );
};

export default BookRoom;